
import AdminPasswordModal from "~/components/Modal/Password.vue";
import { BellIcon } from "@vue-hero-icons/outline";
import ProjectLink from "./ProjectLink.vue";

export default {
  components: {
    AdminPasswordModal,
    BellIcon,
  },
  // computed: {
  //   // 1. Checks if the current session has successfully authenticated
  //   isAccessGranted() {
  //     // Assuming this state is set to TRUE upon successful login via the modal
  //     return this.$$displayAdminGuard;
  //   },

  //   // 2. Checks if the backend requires a password at all (The optional part)
  //   isSecurityEnabled() {
  //     // You need to load this state/config when the app mounts or the component loads.
  //     // For example, fetch it in Nuxt's 'fetch' or 'asyncData'.
  //     return this.$store.state.config.adminSecurityEnabled;
  //   },
  // },
  computed: {
    customer() {
      return this.$get(this.$$users, "user", "");
    },

    userPlanActive() {
      return this.$get(this.$$subscriptions, "status") === 'active';
    },

    isLimitPackage() {
      return !this.userPlanActive;
    },
  },
};
